import { inject, Injectable } from '@angular/core';
import { I18nService, EuiServiceStatus } from '@eui/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from './shared/services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AppStarterService {
  private readonly i18nService = inject(I18nService);
  private authenticationService = inject(AuthenticationService);

  start(): Observable<EuiServiceStatus> {
    return this.authenticationService.getUserAuthenticated$().pipe(
      switchMap(() => this.i18nService.init())
    );
  }
}
